import { render, staticRenderFns } from "./PrincipalTrabajador.vue?vue&type=template&id=007d47f9"
import script from "./PrincipalTrabajador.vue?vue&type=script&lang=js"
export * from "./PrincipalTrabajador.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PrincipalTrabajador.vue?vue&type=style&index=1&id=007d47f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports